import { createContext, useContext } from 'react';

const TemplateEditorExitPathContext = createContext<{ exitPath?: string }>({ exitPath: undefined });

export function TemplateEditorExitPathContextProvider({
  children,
  exitPath,
}: {
  children: React.ReactNode;
  exitPath?: string;
}) {
  return (
    <TemplateEditorExitPathContext.Provider value={{ exitPath }}>
      {children}
    </TemplateEditorExitPathContext.Provider>
  );
}

export function useTemplateEditorExitPath() {
  const context = useContext(TemplateEditorExitPathContext);

  if (process.env.NODE_ENV !== 'production') {
    if (context === undefined) {
      throw new Error(
        'useTemplateEditorExitPath must be used within a TemplateEditorExitPathContextProvider'
      );
    }
  }

  return context;
}
